export default "__VITE_ASSET__IzzXELeJ__"